import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import React from 'react'

import { TruncatedObservation } from '../components'
import { formatTaskDate, findComboItem, findEstadoByKey } from '../utils'
import { mapEstadoForPeticionario } from '../constants'

export const useTaskProcessing = (tasksData, combos, canViewInternalStates, onObservationClick) => {
  const intl = useIntl()

  const processedTasks = useMemo(() => {
    if (!tasksData?.length) return []

    return tasksData.map((task, index) => {
      const tipologia = findComboItem(combos.tipologias_tareas, task.tipologia_id)

      const estado = findEstadoByKey(combos.estados_sspp, task.estado)

      const documentoCampo = findComboItem(combos.subtipologias_tareas, task.tipologia_id)

      const fechaFormateada = formatTaskDate(task.dg_ts_insert, intl)

      let estadoNombre = estado ? estado.value : `Estado ${task.estado}`
      if (!canViewInternalStates && estado?.value) {
        estadoNombre = mapEstadoForPeticionario(estado.value)
      }

      return {
        ...task,
        id: task.id || `row-${index}`,
        tipologia_nombre: tipologia ? tipologia.value : `Tipología ${task.tipologia_id}`,
        estado_nombre: estadoNombre,
        documento_campo: documentoCampo ? documentoCampo.value : '--',
        dg_ts_insert_formatted: fechaFormateada,
        observaciones_sspp: (
          <TruncatedObservation
            text={task.observaciones_sspp || '--'}
            onClick={() => onObservationClick(task.observaciones_sspp)}
          />
        ),
      }
    })
  }, [
    tasksData,
    combos.tipologias_tareas,
    combos.estados_sspp,
    combos.subtipologias_tareas,
    intl,
    canViewInternalStates,
    onObservationClick,
  ])

  return processedTasks
}
